import { Controller } from 'stimulus';
import { SearchItemContainer } from './search_item_container';

/**
 * Shared Stimulus behavior for address and advanced address filter cards:
 * open/expand on load, bind summary refresh events, and update the card summary line.
 */
export class AddressSearchContainerControllerBase extends Controller {
  connect() {
    this.hasAppliedInitialFocus = false;
    this.boundRefreshSummary = this.refreshSummary.bind(this);
    this.boundAfterFieldsReload = this.afterFieldsReload.bind(this);
    this.bindSummaryEvents();
    window.setTimeout(() => {
      this.open();
      this.refreshSummary();
      this.focusInitialField();
    }, 0);
  }

  disconnect() {
    this.unbindSummaryEvents();
  }

  open() {
    const $card = $(this.element).children('.c-card').first();
    if (!$card.length) return;

    SearchItemContainer.checkContainer($card, true);
    SearchItemContainer.expandContainer($card, true);
  }

  bindSummaryEvents() {
    $(this.element).on('change input', '.field-wrapper :input', this.boundRefreshSummary);
    $(this.element).on('select2:close', '.field-wrapper select', this.boundRefreshSummary);
    window.addEventListener('searchForm:fieldsReloaded', this.boundRefreshSummary);
    window.addEventListener('searchForm:fieldsReloaded', this.boundAfterFieldsReload);
    window.addEventListener('filterForm:reloaded', this.boundRefreshSummary);
    window.addEventListener('searchForm:dateFieldsReady', this.boundRefreshSummary);
  }

  unbindSummaryEvents() {
    $(this.element).off('change input', '.field-wrapper :input', this.boundRefreshSummary);
    $(this.element).off('select2:close', '.field-wrapper select', this.boundRefreshSummary);
    window.removeEventListener('searchForm:fieldsReloaded', this.boundRefreshSummary);
    window.removeEventListener('searchForm:fieldsReloaded', this.boundAfterFieldsReload);
    window.removeEventListener('filterForm:reloaded', this.boundRefreshSummary);
    window.removeEventListener('searchForm:dateFieldsReady', this.boundRefreshSummary);
  }

  afterFieldsReload() {
    this.open();
    this.refreshSummary();
  }

  focusInitialField() {
    if (this.hasAppliedInitialFocus) return;

    const input = this.initialFocusElement();
    if (!input) return;

    this.hasAppliedInitialFocus = true;
    window.setTimeout(() => input.focus(), 0);
  }

  refreshSummary() {
    const $card = $(this.element).children('.c-card').first();
    if (!$card.length) return;

    const parts = [];
    const self = this;
    $card.find('.field-wrapper').each(function() {
      const segment = self.summarizeRow($(this));
      if (segment) parts.push(segment);
    });

    const summary = parts.join(' · ');
    const $summary = $card.children('.c-card-enable-summary').first();
    const isChecked = $card.find('input[type=checkbox].filter_item_container').prop('checked');
    $summary.text(summary);
    $summary.css('color', isChecked ? '#0077d9' : '#a6a6a6');
  }

  /** @returns {HTMLElement|null} */
  initialFocusElement() {
    return null;
  }

  /** @param {JQuery} _$row */
  summarizeRow(_$row) {
    return '';
  }
}
